class Announcement extends HTMLElement {
   constructor() {
      super()
   }
   connectedCallback() {
      this.blocks = this.querySelectorAll(".announcement--block"), this.next_arrow = this.querySelector(".announcement--next"), this.previous_arrow = this.querySelector(".announcement--previous"), this.rotate_frequency = parseInt(this.getAttribute("data-rotate-frequency")), this.getActiveBlocks(), this.startTimer(), this.resizeListeners(), Shopify.designMode && this.blocks.length > 1 && this.editorListeners()
   }
   getActiveBlocks() {
      this.active_blocks = [], this.blocks.forEach(t => {
         t.removeAttribute("data-index"), this.isBlockActive(t) && this.active_blocks.push(t)
      }), this.active_blocks.forEach((t, e) => {
         0 === e && t.setAttribute("data-transition-type", "slide-out"), t.setAttribute("data-index", e)
      }), this.previous_index = 0, this.next_index = 0, this.next_arrow && this.previous_arrow && this.toggleArrows(1 < this.active_blocks.length)
   }
   isBlockActive(t) {
      return "small" === theme.mqs.current_window && "small" === t.dataset.mq || "medium" === theme.mqs.current_window && "medium-large" === t.dataset.mq || "large" === theme.mqs.current_window && "medium-large" === t.dataset.mq || "" === t.dataset.mq
   }
   toggleArrows(t) {
      this.next_arrow.setAttribute("aria-hidden", !t), this.previous_arrow.setAttribute("aria-hidden", !t), t ? this.arrowListeners() : [this.next_arrow, this.previous_arrow].off("click")
   }
   arrowListeners() {
      this.next_arrow.on("click", () => {
         this.disabled_click || (this.updateIndices(!1), this.updateBlocks(), this.timer && clearInterval(this.timer))
      }), this.previous_arrow.on("click", () => {
         this.disabled_click || (this.updateIndices(!0), this.updateBlocks(), this.timer && clearInterval(this.timer))
      })
   }
   startTimer() {
      this.active_blocks.length < 2 || (this.timer = setInterval(() => {
         this.updateIndices(!1), this.updateBlocks()
      }, 1e3 * this.rotate_frequency))
   }
   resetBlocks() {
      this.active_blocks.forEach((t, e) => {
         var i = e === this.previous_index;
         t.off("transitionend"), t.setAttribute("aria-hidden", !i), t.setAttribute("data-transition-active", !1), t.setAttribute("data-transition-type", i ? "slide-out" : "slide-in")
      })
   }
   updateBlocks() {
      const e = this.active_blocks[this.next_index],
         i = this.active_blocks[this.previous_index];
      this.pending_transition && this.resetBlocks(), i.on("transitionend", ({
         target: t
      }) => {
         t == i && (this.pending_transition = !1, e.setAttribute("aria-hidden", !1), e.setAttribute("data-transition-active", !0), i.setAttribute("aria-hidden", !0), i.setAttribute("data-transition-type", "slide-in"), i.setAttribute("data-transition-active", !1), i.off("transitionend"))
      }), e.on("transitionend", ({
         target: t
      }) => {
         t == e && (this.disabled_click = !1, e.setAttribute("data-transition-type", "slide-out"), e.setAttribute("data-transition-active", !1), e.off("transitionend"))
      }), this.disabled_click = !0, this.pending_transition = !0, i.setAttribute("data-transition-active", !0)
   }
   updateIndices(t) {
      this.previous_index = this.next_index, this.next_index = t ? this.previous_index - 1 < 0 ? this.active_blocks.length - 1 : this.previous_index - 1 : this.previous_index + 1 === this.active_blocks.length ? 0 : this.previous_index + 1
   }
   resizeListeners() {
      window.on("theme:mqs:updated", () => {
         this.getActiveBlocks(), this.resetBlocks()
      }), new ResizeObserver(() => this.measureHeight()).observe(this)
   }
   measureHeight() {
      document.documentElement.style.setProperty("--announcement--height", this.offsetHeight + "px")
   }
   editorListeners() {
      this.blocks.on("theme:block:deselect", () => {
         this.startTimer()
      }), this.blocks.on("theme:block:select", ({
         target: t
      }) => {
         this.isBlockActive(t) && (this.next_index = parseInt(t.getAttribute("data-index")), this.previous_index = this.next_index - 1 < 0 ? this.active_blocks.length - 1 : this.next_index - 1, this.pending_transition = !0, this.updateBlocks(), this.timer) && clearInterval(this.timer)
      }), this.on("theme:section:reorder", () => {
         this.timer && clearInterval(this.timer)
      }), document.on("shopify:inspector:activate", () => {
         this.parentNode.style.position = "relative", this.parentNode.style.top = "unset"
      }), document.on("shopify:inspector:deactivate", () => {
         setTimeout(() => {
            this.parentNode.removeAttribute("style")
         }, 0)
      })
   }
}
const announcementEl = customElements.get("announcement-bar");
announcementEl || customElements.define("announcement-bar", Announcement);